import type { ShadowLocation } from "../../types/location-map";

/** Format a location address for list/header display. */
export const formatLocationAddress = (location: ShadowLocation): string => {
	const address = location.address;
	if (!address) return "No address";
	const parts = [
		address.street1,
		address.city,
		address.stateProvince,
		address.postalCode,
		address.country,
	].filter(Boolean);
	return parts.length > 0 ? parts.join(", ") : "No address";
};
